module.exports = __webpack_public_path__ + "img/code.48d2131d.jpg";